import { Container, Row } from "reactstrap";
import BasicPopover from "./BasicPopover";
import { Breadcrumbs } from "../../../AbstractElements";
import { PopoverTitle, UiKits } from "../../../Constants/Constants";
import PopoverDirection from "./PopoverDirection";
import PopoverOffset from "./PopoverOffset";

const PopoverContainer = () => {
  return (
    <>
    <Breadcrumbs mainTitle={PopoverTitle} parent={UiKits}/>
    <Container fluid>
      <Row className="popover-main">
        <BasicPopover />
        <PopoverDirection />
        <PopoverOffset />
      </Row>
    </Container>
    </>
  );
};
export default PopoverContainer;
